module.exports = __webpack_public_path__ + "10_hair_silver.8a934009.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/10_hair_silver.png
// module id = x5Xr
// module chunks = 0